import React from "react";
import Scene from "./Scene";
import SceneEffects from "./SceneEffects";

export default function SceneBackground({ effectsProps = {}, sceneProps = {} } = {}) {
  return (
    <>
      <Scene {...sceneProps} />
      <SceneEffects {...effectsProps} />
    </>
  );
}

